import { isEmpty } from 'lodash';
import React from 'react';
import { FilterSelect } from './styles/VenuesFilter.styled';

export default function VenuesFilterSelect({ data }) {
  // console.log(data);
  const { isArabic, options, placeholder } = data;
  const [isOpen, setIsOpen] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(placeholder);
  const isBrowser = typeof window !== 'undefined';

  React.useEffect(() => {
    if (isBrowser) {
      const elementsList = document.querySelector('.dropdown__menu-list');
      if (!isEmpty(elementsList)) {
        const optionElements = Array.from(elementsList.childNodes);
        const selectedElement = optionElements.find((value) => value.innerText === selectedOption);
        if (!isEmpty(selectedElement)) {
          const currElement = document.getElementById(selectedElement.id);
          currElement.classList.add('selected-option');
        }
      }
    }
  }, [isOpen]);

  const settings = {
    isArabic,
    classNamePrefix: 'dropdown',
    onMenuOpen: () => setIsOpen(true),
    onMenuClose: () => setIsOpen(false),
    // defaultMenuIsOpen: true,
    onChange: ({ label }) => {
      setSelectedOption(label);
      // onChange(label);
    },
    isOpen,
    placeholder,
    options,
  };

  return <FilterSelect {...settings} />;
}
